const dbModel = {
  category: null,
  items: null
};

export default dbModel;
